import axiosClient from "@/services/shared/api/axios-client";
import config from "@/config/config";
import { requestPasswordResetMock } from "./forgotPassword.mocks";

const API_URL = "/password/forgot";

// Real API implementation
const requestPasswordResetApi = async (email: string) => {
  await axiosClient.post(API_URL, { email });
};

// Export service that selects between real and mock implementation
export const requestPasswordReset = config.selectApi(requestPasswordResetApi, requestPasswordResetMock);
